import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';

const shortcodeGenerator = () => {
  const generatedBox = document.getElementById('shortcode-generator__generated');
  if (generatedBox) {
    /*------------ [SHORTCODE GENERATOR] ------------*/
    let buildShortcode = () => {
      let nameElement = document.getElementById('shortcode-generator__name'),
        templateElement = document.getElementById('shortcode-generator__template'),
        searchCountryElement = document.getElementById('shortcode-generator__search-country'),
        searchCountryWrapper = document.getElementById('shortcode-generator__search-country--wrapper'),
        searchLanguageElement = document.getElementById('shortcode-generator__search-language'),
        searchLanguageWrapper = document.getElementById('shortcode-generator__search-language--wrapper'),
        searchTypeElement = document.getElementById('shortcode-generator__search-type'),
        searchTypeWrapper = document.getElementById('shortcode-generator__search-type--wrapper'),
        geolocalisationElement = document.getElementById('shortcode-generator__geolocalisation'),
        filtersElement = document.getElementById('shortcode-generator__filters'),
        filtersWrapper = document.getElementById('shortcode-generator__filters--wrapper'),
        typesElement = document.getElementById('shortcode-generator__types'),
        typesValues = Array.from(typesElement.selectedOptions).map(v => v.value);

      let name = '',
        types = '',
        template = '',
        searchTypes = '',
        searchCountry = '',
        searchLanguage = '',
        geolocalisation = '',
        filters = '';

      if (typesValues.length !== 0) {
        types = `type="${typesValues.join().toLowerCase()}"`;
      }
      if (nameElement.value.toLowerCase() !== '') {
        name = `title="${nameElement.value}"`;
      }
      if (geolocalisationElement.value.toLowerCase() !== 'false') {
        geolocalisation = `geolocalisation="${geolocalisationElement.value}"`;
      }
      if (templateElement.value.toLowerCase() !== 'full') {
        template = `template="${templateElement.value}"`;
        searchCountryWrapper.classList.add('is-hidden');
        searchLanguageWrapper.classList.add('is-hidden');
        searchTypeWrapper.classList.add('is-hidden');
        filtersWrapper.classList.add('is-hidden');
      } else {
        searchCountryWrapper.classList.remove('is-hidden');
        searchLanguageWrapper.classList.remove('is-hidden');
        searchTypeWrapper.classList.remove('is-hidden');
        filtersWrapper.classList.remove('is-hidden');
        if (filtersElement.value.toLowerCase() !== 'true') {
          filters = `filters="${filtersElement.value}"`;
        }
        if (searchTypeElement.value.toLowerCase() === 'custom') {
          searchTypes = `search-type="${searchTypeElement.value}"`;
          searchCountryWrapper.classList.add('is-hidden');
          searchLanguageWrapper.classList.add('is-hidden');
        } else if (searchTypeElement.value.toLowerCase() === 'leaflet') {
          searchTypes = `search-type="${searchTypeElement.value}"`;
          searchCountryWrapper.classList.remove('is-hidden');
          searchLanguageWrapper.classList.remove('is-hidden');
          if (searchCountryElement.value.toLowerCase() !== '') {
            searchCountry = `search-country="${searchCountryElement.value}"`;
          }
          if (searchLanguageElement.value.toLowerCase() !== '') {
            searchLanguage = `search-language="${searchLanguageElement.value}"`;
          }
        }
      }
      let shortcode = `[map ${name} ${types} ${filters} ${geolocalisation} ${template} ${searchTypes} ${searchCountry} ${searchLanguage}]`;
      generatedBox.innerHTML = shortcode;
    };

    document.getElementById('shortcode-generator__name').addEventListener('input', buildShortcode, false);
    document.getElementById('shortcode-generator__search-country').addEventListener('input', buildShortcode, false);
    document.getElementById('shortcode-generator__search-language').addEventListener('input', buildShortcode, false);
    document.getElementById('shortcode-generator__template').addEventListener('change', buildShortcode, false);
    document.getElementById('shortcode-generator__geolocalisation').addEventListener('change', buildShortcode, false);
    document.getElementById('shortcode-generator__filters').addEventListener('change', buildShortcode, false);
    document.getElementById('shortcode-generator__search-type').addEventListener('change', buildShortcode, false);
    document.getElementById('shortcode-generator__types').addEventListener('change', buildShortcode, false);
    buildShortcode();
  }
}


export { shortcodeGenerator }
